<template>
  <nav class="auth-register__stepper" aria-label="Registration progress">
    <p class="auth-register__stepper-heading">Your progress</p>
    <ol class="auth-register__stepper-list">
      <li
        v-for="(step, index) in steps"
        :key="step.id"
        class="auth-register__stepper-item"
        :class="{
          'auth-register__stepper-item--active': step.id === currentStep,
          'auth-register__stepper-item--complete': step.id < currentStep,
          'auth-register__stepper-item--last': index === steps.length - 1,
        }"
      >
        <div class="auth-register__stepper-track" aria-hidden="true">
          <span class="auth-register__stepper-marker">
            <AuthIcon v-if="step.id < currentStep" name="step-complete" :size="14" :stroke-width="2.5" />
            <span v-else class="auth-register__stepper-number">{{ step.id }}</span>
          </span>
          <span v-if="index < steps.length - 1" class="auth-register__stepper-line" />
        </div>

        <div class="auth-register__stepper-content">
          <span class="auth-register__stepper-label">{{ step.label }}</span>
          <span v-if="step.description" class="auth-register__stepper-desc">{{ step.description }}</span>
        </div>
      </li>
    </ol>
  </nav>
</template>

<script setup>
import AuthIcon from './AuthIcon.vue'

defineProps({
  steps:       { type: Array, required: true },
  currentStep: { type: Number, required: true },
})
</script>
